import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Navigate } from "react-router-dom";
import { InquiryStatus } from "../../../domain/inquiry/Inquiry";
import { Paths } from "../../../Paths";
import { useAppDispatch } from "../../../state/store";
import { getInquiryDetailAction, updateInquiryAction } from "../../../state/usecase/inquiry/actions";
import { useInquiryDetail } from "../../hooks/inquiry/useInquiryDetail";
import { Button } from "../common/button/Button";
import { InputTextArea } from "../common/input/InputTexArea";
import { Loading } from "../common/Loading";
import { ArrowLineIcon } from "../information/icons/ArrowLineIcon";
import StatusSelector from "./components/StatusSelector";

type InquiryParams = {
    inquiryId: string
} 

export default function InquiryDetail() {

    const params = useParams<InquiryParams>();
    const dispatch = useAppDispatch();
    const { inquiryId } = params;
    const { inquiry, processing } = useInquiryDetail();

    const [memo, setMemo] = useState<string>(inquiry?.memo?.value ?? "");

    if (!inquiryId) {
        return <Navigate to={Paths.root} />;
    }
    useEffect(() => {
        dispatch(getInquiryDetailAction({ id: inquiryId }));
    }, []);

    useEffect(() => {
        if (inquiry?.memo) {
            setMemo(inquiry.memo.value);
        }
    }, [inquiry]);

    const navigate = useNavigate();

    if (!inquiry || processing) {
        return <Loading/>;
    }

    const onClickBackButton = () => {
        navigate(`${Paths.admin}${Paths.inquiry}`);
    };

    const updateInquiryStatus = (status: InquiryStatus) => {
        dispatch(updateInquiryAction({
            id: inquiry.id,
            status: status,
            successMessage: "問い合わせステータスを更新しました"
        }));
    };

    const handleClickUpdateMemo = () => {
        dispatch(updateInquiryAction({
            id: inquiry.id,
            memo: memo,
            successMessage: "問い合わせメモを更新しました"
        }));
    };

    const deletedUser = inquiry.user === null;

    return (
        <div className="inquiry_detail">
            <button className="back_button" onClick={onClickBackButton}>
                <ArrowLineIcon/>
                <div className="text">一覧へ戻る</div>
            </button>
            <h1 className="title">問い合わせ詳細</h1>
            <main className="main">
                <div className="content_side">
                    <div className="label">問い合わせ内容</div>
                    <div className="content">
                        { inquiry.content.value }
                    </div>
                </div>
                <div className="info_side">
                    <div className="info">
                        <p className="label">ステータス</p>
                        <StatusSelector currentStatus={inquiry.status} handleSelectStatus={updateInquiryStatus}/>
                    </div>
                    <div className="info">
                        <p className="label">問い合わせ日時</p>
                        <p>{inquiry.createdAt.format("/")}</p>
                    </div>
                    <div className="info">
                        <p className="label">問い合わせユーザー</p>
                        <p className={classNames({ "deleted_user": deletedUser })}>{inquiry.user?.name.value ?? "削除済みユーザー"}</p>
                        <div className="info__additional">
                            <p>メールアドレス:  {inquiry.user?.email.value ?? "-"}</p>
                        </div>
                    </div>
                    <div className="info">
                        <p className="label">連絡先情報</p>
                        <div className="info__additional">
                            <p>連絡先メールアドレス: {inquiry.contactEmail.value}</p>
                            <p>電話番号:  {inquiry.tel ?? "-"}</p>
                        </div>
                    </div>
                    <div className="info">
                        <p className="label">利用者情報</p>
                        <p>{inquiry.careRecipient?.name.value ?? "-"}</p>
                        <div className="info__additional">
                            <p>ハウスID: {inquiry.careRecipient?.houseId.value ?? "-"}</p>
                        </div>
                    </div>
                </div>
            </main>
            <div className="memo_area">
                <h2 className="small_title">問い合わせ対応メモ</h2>
                <div className="memo">
                    <InputTextArea value={memo} handleTextChanged={function (value: string): void {
                        setMemo(value);
                    } }/>
                </div>
                <div className="memo_update_button_area">
                    <Button onClick={handleClickUpdateMemo} label={"メモを更新する"}></Button>
                </div>
            </div>
        </div>
    );
}
